import { render, staticRenderFns } from "./specialtyAccordionInput.vue?vue&type=template&id=11a0db34&scoped=true&"
import script from "./specialtyAccordionInput.vue?vue&type=script&lang=js&"
export * from "./specialtyAccordionInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a0db34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VExpandTransition,VIcon})
